import { processHtmlAttributes } from "../../../../common/html-attributes/index.js";
static {}
$ const {
  as: inputAs,
  class: inputClass,
  ...htmlInput
} = input;
<${inputAs || "div"} class=["skeleton__image", inputClass] ...processHtmlAttributes(htmlInput)/>